/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Input,
  Button,
  IdentityNumberSearch,
  IdentityClientCardSmall,
  IdentityContactCardSmall
} from '../'

export class IdentityNumberFinder extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    onCreateCaseClick: PropTypes.func.isRequired,
    numberFoundAdditionalRender: PropTypes.func,
    className: PropTypes.string
  }

  static defaultProps = {
    label: 'ID number'
  }

  constructor(props) {
    super(props)

    this.state = {
      idNumber: '',
      search: false
    }
  }

  handleChange = (e) => {
    if (this.state.search) {
      this.setState({ idNumber: e.target.value, search: false })
    } else {
      this.setState({ idNumber: e.target.value })
    }
  }

  handleClick = () => this.setState({ search: true })

  render() {
    return (
      <div className={this.props.className ? this.props.className : ''}>
        {this.props.label}
        <Input
          value={this.state.idNumber}
          onChange={this.handleChange}
          className='slds-large-size_1-of-3 slds-medium-size_1-of-4 slds-small-size_1-of-2 slds-m-top_small slds-m-bottom_large'
        />
        <Button
          type='brand'
          onClick={this.handleClick}
          disabled={this.state.idNumber.length === 0}
          minWidth={150}
          className='slds-m-bottom_xx-large'>
          Find
        </Button>
        {this.state.search &&
          <IdentityNumberSearch
            idNumber={this.state.idNumber}
            render={foundIdentityObject => foundIdentityObject
              ? <IDFound
                  identityObj={foundIdentityObject}
                  additionalRender={this.props.numberFoundAdditionalRender}
                />
              : <IDNotFound onCaseCreateClick={this.props.onCreateCaseClick} />
            }
          />
        }
      </div>
    )
  }
}

const IDFound = ({ identityObj, additionalRender }) => (
  <div>
    <div className='u-font-weight-bold u-font-size-larger'>
      {`${identityObj.firstName} ${identityObj.lastName}, matching the ID number, exists on PicsaOS.
        Please confirm whether it is the same person.`}
    </div>
    {identityObj.isContact && identityObj.client === null
      ? <IdentityContactCardSmall identity={identityObj.id} className='slds-m-top_medium slds-m-bottom_large' />
      : <IdentityClientCardSmall identity={identityObj.id} className='slds-m-top_medium slds-m-bottom_large' />
    }
    {additionalRender && additionalRender(identityObj)}
  </div>
)

const IDNotFound = ({ onCaseCreateClick }) => (
  <div className='u-font-size-larger'>
    <b>This ID is not assigned to a member. Check that the ID number was entered correctly, or create a case.</b>
    <br />
    <Button
      type='brand'
      minWidth={150}
      onClick={onCaseCreateClick}
      className='slds-text-body_default slds-m-top_medium slds-m-bottom_large'>
      Create a case
    </Button>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/identity-number-finder/index.js